module.exports = __webpack_public_path__ + "img/gridbg2.bc9c0fb0.png";